import { z } from "zod";

import { OnsiteEditDtoSchema } from "../../../../dtos/onsite-edits";

export const PluginOnsiteEditSchema_2024_05_05 = OnsiteEditDtoSchema;
export type PluginOnsiteEditType_2024_05_05 = z.infer<
  typeof PluginOnsiteEditSchema_2024_05_05
>;
